import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@fluid/buttons';

const LoginLocales = (props) => {
    const {
        contextCls,
        supportedLocales = [],
        isInteractive,
        onLocaleSelect,
    } = props;

    if (!supportedLocales || !supportedLocales.length) {
        return false;
    }

    const handleClick = ({ data }) => {
        if (isInteractive && onLocaleSelect) {
            onLocaleSelect(data);
        }
    };

    const localeItems = supportedLocales.map((item) => {
        const nonInteractiveProps = {};

        if (!isInteractive) {
            nonInteractiveProps.tabIndex = '-1';
        }

        return (
            <li key={item.locale}>
                <Button
                    data={item.locale}
                    onClick={handleClick}
                    isLink
                    {...nonInteractiveProps}
                >
                    {item.displayText}
                </Button>
            </li>
        );
    });

    return <ul className={contextCls}>{localeItems}</ul>;
};

LoginLocales.defaultProps = {};

LoginLocales.propTypes = {
    contextCls: PropTypes.string,
    supportedLocales: PropTypes.arrayOf(
        PropTypes.shape({
            locale: PropTypes.string.isRequired,
            displayText: PropTypes.string.isRequired,
        }),
    ),
    isInteractive: PropTypes.bool,
    onLocaleSelect: PropTypes.func,
};

export default LoginLocales;
